import { Icon, icons } from '../../../generic/Icon';
import type { TooltipPlacement } from '../../../generic';
import Tooltip from '../../../generic/Tooltip';
import { cveStatusToInfo } from '../../../../../shared/vulns/cveStatus';
import type { CVEStatus } from '../../../../../typings/enums';

type Props = {
  status: CVEStatus;
  tooltipPlacement?: TooltipPlacement;
};

/**
 * Render CVE status text with tooltip providing more information.
 *
 * @param {Props} props - The props.
 * @param {CVEStatus} props.status of the CVE
 * @param {TooltipPlacement} props.tooltipPlacement - The tooltip placement when hovering over the info icon.
 */
const CVEStatusText = ({ status, tooltipPlacement }: Props) => {
  const info = cveStatusToInfo[status];
  return (
    <div>
      <span>
        {info.name}
      </span>
      <Tooltip id={`CVEStatusText-${info.name}`} tooltip={info.tooltip} placement={tooltipPlacement || 'top'}>
        <span className="margin-left-xs">
          <Icon icon={icons.infoCircle} />
        </span>
      </Tooltip>
    </div>
  );
};

export default CVEStatusText;
